import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';

/***** STYLES *****/
import * as styles from './Link.css';
import { jsx as _jsx } from "react/jsx-runtime";
/***** COMPONENT *****/
export function Link(props) {
  var children = props.children,
    id = props.id,
    onClick = props.onClick,
    url = props.url,
    linkStyle = props.linkStyle,
    _props$target = props.target,
    target = _props$target === void 0 ? 'self' : _props$target,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$dataMark = props.dataMark,
    dataMark = _props$dataMark === void 0 ? 'Link' : _props$dataMark,
    rel = props.rel;
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    target: "_".concat(target),
    title: title,
    id: id,
    "data-mark": dataMark,
    onClick: function (_onClick) {
      function onClick(_x) {
        return _onClick.apply(this, arguments);
      }
      onClick.toString = function () {
        return _onClick.toString();
      };
      return onClick;
    }(function (event) {
      if (onClick) {
        onClick(event);
      }
    }),
    href: url
  }, mergeStyles(styles['element'], linkStyle)), {}, {
    rel: rel,
    children: children
  }));
}